import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/page/index'
import List from '@/page/list'
import searchList from '@/page/searchList'

import Subscribe from '@/page/subscribe'
import Mission from '@/page/mission'
import Referral from '@/page/referral'
import MyPoints from '@/page/myPoints'
import LuckyDraw from '@/page/luckyDraw'
import RedeemCenter from '@/page/redeemCenter'
import Language from '@/page/language'
import Game from '@/page/game'
import Faq from '@/page/faq'
import MyAccount from '@/page/myAccount'
import MyGames from '@/page/myGames'
import ChangePassword from '@/page/changePassword'
import TermsAndCondition from '@/page/termsAndCondition'
import TC from '@/page/TC'
import Error from '@/page/error'

import Register from '@/page/Register'
import Login from '@/page/Login'
import Login2 from '@/page/Login2'
import SendOtp from '@/page/sendOtp'
import LoginDaily from '@/page/LoginDaily'
import LoginWeek from '@/page/LoginWeek'
import SendDailyOtp from '@/page/SendDailyOtp'
import SendWeekOtp from '@/page/SendWeekOtp'

Vue.use(Router)

export default new Router({
  // mode: 'history',  // 加入这一句即可去除url的#
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: ''
		}
    }
    ,{
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        title: 'Register'
      }
    }
    ,{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },{
      path: '/login2',
      name: 'login2',
      component: Login2,
      meta: {
        title: 'Login'
      }
    },{
		path: '/sendOtp',
		name: 'SendOtp',
		component: SendOtp,
		meta: {
			title: 'Send Otp'
		}
    },{
		path: '/list',
		name: 'list',
		component: List,
		meta: {
			title: ''
		}
    },{
		path: '/searchList',
		name: 'searchList',
		component: searchList,
		meta: {
			title: ''
		}
    },{
		path: '/myAccount',
		name: 'myAccount',
		component: MyAccount,
		meta: {
			title: ''
		}
    },{
		path: '/faq',
		name: 'faq',
		component: Faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/TC',
		name: 'TC',
		component: TC,
		meta: {
			title: 'Terms and Condition'
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: TermsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },{
		path: '/subscribe',
		name: 'subscribe',
		component: Subscribe,
		meta: {
			title: 'subscribe'
		}
    },{
		path: '/mission',
		name: 'mission',
		component: Mission,
		meta: {
			title: 'mission'
		}
    },{
      path: '/referral',
      name: 'referral',
      component: Referral,
      meta: {
        title: 'referral'
      }
    },{
      path: '/myPoints',
      name: 'myPoints',
      component: MyPoints,
      meta: {
        title: 'myPoints'
      }
    },{
      path: '/luckyDraw',
      name: 'luckyDraw',
      component: LuckyDraw,
      meta: {
        title: 'luckyDraw'
      }
    },{
      path: '/redeemCenter',
      name: 'redeemCenter',
      component: RedeemCenter,
      meta: {
        title: 'redeemCenter'
      }
    },{
      path: '/language',
      name: 'language',
      component: Language,
      meta: {
        title: 'language'
      }
    },{
      path: '/game',
      name: 'game',
      component: Game,
      meta: {
        title: 'game'
      }
    },{
      path: '/myGames',
      name: 'myGames',
      component: MyGames,
      meta: {
        title: 'myGames'
      }
    },{
      path: '/changePassword',
      name: 'changePassword',
      component: ChangePassword,
      meta: {
        title: 'changePassword'
      }
    },{
      path: '/error',
      name: 'error',
      component: Error,
      meta: {
        title: 'Error'
      }
    },{
      path: '/LoginDaily',
      name: 'LoginDaily',
      component: LoginDaily,
      meta: {
        title: 'LoginDaily'
      }
    },{
      path: '/LoginWeek',
      name: 'LoginWeek',
      component: LoginWeek,
      meta: {
        title: 'LoginWeek'
      }
    },{
      path: '/SendDailyOtp',
      name: 'SendDailyOtp',
      component: SendDailyOtp,
      meta: {
        title: 'SendDailyOtp'
      }
    },{
      path: '/SendWeekOtp',
      name: 'SendWeekOtp',
      component: SendWeekOtp,
      meta: {
        title: 'SendWeekOtp'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js